import type { AxiosResponse } from "axios";
import { executePost } from "../../../../utils/appUtils";

const optOutErrorAndReqPin = (isOptOutParams): Promise<AxiosResponse> => {
    const optOutErrorAndReqPinApi = `/participant-web-services/rest/partialauth/optOutErrorRequestPin/${isOptOutParams.optOut}`;
    return executePost(optOutErrorAndReqPinApi, "optOutErrorAndReqPinFault", { ...isOptOutParams });
};
export default optOutErrorAndReqPin;
